import * as S from "@styled";
import { device } from "shared/styles/helpers";
import { NavBarHeight, ThemeType } from "shared/styles/theme";
import styled from "styled-components";
import theme from "styled-theming";

const navbarBackgroundColor = theme.variants("mode", "variant", {
    default: { [ThemeType.light]: S.Colors.white, [ThemeType.dark]: S.Colors.dark3 },
    production: { [ThemeType.light]: S.Colors.orangeTertiary, [ThemeType.dark]: S.Colors.dark3 }
});

const navbarTextColor = theme.variants("mode", "variant", {
    default: { [ThemeType.light]: S.Colors.black, [ThemeType.dark]: S.Colors.grey_5 },
    production: { [ThemeType.light]: S.Colors.grey_5, [ThemeType.dark]: S.Colors.white }
});

const dropdownNavLink = theme("mode", {
    [ThemeType.light]: S.Colors.purplePrimary,
    [ThemeType.dark]: S.Colors.purpleTertiary
})

export const Navbar = styled.ul`
    list-style-type: none;
    margin: 0;
    padding: 0;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 8px 10px 8px 8px;
    @media ${device.laptopL} {
        padding: 8px 10px 8px 24px;
    }
    width: 100%;
    height: ${NavBarHeight};
    font-size: 1rem;
    background-color: ${navbarBackgroundColor};
    li {
        float: left;
        padding: 14px;

        a > i {
            font-size: var(--header-4-font-size);
        }
    }

    .frends-logo {
        padding: 0 16px 0 0;
    }

`

export const NavLinkContainer = styled.div`
    display: flex;
    @media ${device.laptopL} {
        height: 100%;
        flex-wrap: wrap;
        align-content: center;
        a, li {
            height: 100%;
            display: flex;
            align-items: center;
        }
    }
`

export const NavLink = styled.a`
    display: flex;
    cursor: pointer;
    color: ${navbarTextColor};
    font-family: "Gilroy-Medium", "medium-fallback";
    font-size: 1rem;
    text-decoration: none;
    &.active {
        font-family: "Gilroy-Bold", "bold-fallback";
    }
`

export const DropdownNavLink = styled(NavLink)`
    &.active {
        font-family: "Gilroy-Medium", "medium-fallback";
        color: ${dropdownNavLink};
    }
`

export const NavText = styled.p`
    font-family: "Gilroy-Medium", "medium-fallback";
    font-size: 1rem;
`

export const NavMobileExpandButton = styled(S.Button)`
    margin-right: 10px;
    padding: 8px;
    border: 0;
    border-radius: 16px;
    font-size: 1.75rem;
    display: flex;
    align-items: center;
    cursor: pointer;
`

NavLink.defaultProps = {
    variant: "default"
};